import { ClientAnalytics } from './clientAnalytics'

type SidebarToggleEvent =
  | 'sidebar:close'

export type SidebarAnalyticsEvent = SidebarToggleEvent

export function trackSidebar(event: SidebarAnalyticsEvent, properties?: Record<string, unknown>) {
  ClientAnalytics.track(event, properties)
}
